import 'choerodon-ui/lib/ripple/style';
